import { Link, useParams } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import TrendingSidebar from '@/pages/home/components/TrendingSidebar';

const articleContentMock: Record<string, string> = {
  'wanghong-douyin-dashen-tafang': `
    <p>近日，拥有超过1200万粉丝的抖音头部网红"XX"在一场深夜直播中因不当言论引发众怒。该网红在直播中对粉丝出言不逊，态度傲慢，与平日塑造的"亲民暖男"人设形成巨大反差。</p>

    <h3>事件经过</h3>
    <p>据悉，当晚直播持续时间超过3小时，该网红在醉酒状态下多次使用不雅语言。更令粉丝失望的是，随后有网友扒出其私下拍摄的多段视频，内容与其在镜头前呈现的"正能量"形象截然不同。</p>

    <h3>粉丝反应</h3>
    <p>消息曝光后，该网红的粉丝数在短时间内暴跌数十万。大量粉丝在评论区表示"人设崩塌""取关了""没想到你是这样的人"。</p>

    <h3>后续发展</h3>
    <p>截至目前，该网红尚未就此事发表正式声明。其合作的品牌方也已开始陆续删除相关推广内容。本站将持续关注事件进展。</p>
  `,
  'mingsu-nanxing-bagua': `
    <p>当红男星"XX"近日被狗仔拍到深夜与神秘女子同回酒店，两人举止亲密，疑似恋情曝光。</p>

    <h3>酒店同框</h3>
    <p>据爆料，当晚男星与一名戴帽子的神秘女子在某高端酒店前台办理入住。两人前后脚进入酒店，但很快被细心的网友发现同行细节。</p>

    <h3>工作室回应</h3>
    <p>男星工作室于凌晨紧急发文回应，称"纯属朋友聚会"，但并未正面回应两人入住同一酒店的问题。网友表示回应"避重就轻"。</p>

    <h3>更多细节</h3>
    <p>有网友扒出该女子此前曾多次出现在男星助理发布的合照中，疑似为男星团队工作人员。</p>
  `,
  'duli-baoliao-zhibojian-neimu': `
    <p>据知情人士向本站独家爆料，某知名带货直播间存在大规模数据造假行为，后台真实销售数据与对外公布数据相差数十倍之多。</p>

    <h3>爆料内容</h3>
    <p>爆料人提供了多张后台截图，显示某场号称"销售额破亿"的直播，实际成交订单不足千单。更惊人的是，大量订单在直播结束后被集中取消退款。</p>

    <h3>数据造假手法</h3>
    <p>据行业人士透露，直播间数据造假已形成完整的灰色产业链。包括刷人气、刷单量、刷评论等手段，成本极低，但效果惊人。</p>

    <h3>行业影响</h3>
    <p>该事件曝光后，已有多家品牌商表示将重新审视与主播的合作模式。监管部门也对此事表示高度关注。</p>
  `,
  'zongyi-jiemu-zhengyi-jianji': `
    <p>近期热播选秀综艺因恶意剪辑再次登上热搜，多位参赛选手公开质疑节目组剪辑手法。</p>

    <h3>选手发声</h3>
    <p>某被淘汰选手在微博上发布长文，详细描述节目录制过程中自己的表现与播出内容的巨大差异，引发网友热议。</p>

    <h3>观众质疑</h3>
    <p>有眼尖的观众发现，同一选手在不同场景中的服装发型存在明显矛盾，疑似将不同时间的镜头拼接在一起。</p>
  `,
  'shehui-redian-gaokao-zuobi': `
    <p>教育部门联合公安部门披露一起重大考试舞弊案件，涉及利用高科技设备在高考中作弊。</p>

    <h3>舞弊手段</h3>
    <p>据通报，犯罪嫌疑人利用改装后的智能手表、微型耳机等设备，在考场外通过无线电向考生传递答案。</p>

    <h3>涉案规模</h3>
    <p>目前已查明涉案人员超过30人，包括考生家长、设备提供者和部分考场工作人员。</p>
  `,
};

function getDefaultContent(title: string): string {
  return `
    <p>近日，关于<strong>${title}</strong>的相关消息在网络上引发广泛关注。据多方消息源透露，事件的细节正逐步浮出水面。</p>

    <h3>事件背景</h3>
    <p>事件最初由网友在某社交平台爆料，随后迅速登上热搜榜单。大量网友参与讨论，相关话题阅读量在短时间内突破千万。</p>

    <h3>核心细节</h3>
    <p>据知情人士透露，事件涉及多方利益相关者。目前已有多位当事人卷入其中，事件的真相仍在进一步调查中。</p>

    <h3>舆论反应</h3>
    <p>事件曝光后，网友们的反应呈现出两极分化的态势。一部分网友表示震惊和失望，另一部分则持观望态度，呼吁等待更多证据。</p>

    <h3>后续展望</h3>
    <p>本站将持续关注此事的最新进展，并第一时间为大家带来后续报道。敬请关注吃瓜黑料在线，不错过任何一个瓜。</p>
  `;
}

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const fallbackArticle = articles[0];
  const article = articles.find((a) => a.slug === slug) || fallbackArticle;

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto flex items-center justify-center mb-4 bg-background-100 rounded-full">
              <i className="ri-file-search-line text-2xl text-foreground-400" />
            </div>
            <h1 className="text-2xl font-heading font-bold text-foreground-900 mb-2">文章未找到</h1>
            <p className="text-foreground-500 mb-4">您访问的文章不存在或已被删除</p>
            <Link to="/" className="inline-block px-6 py-2.5 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const related = articles
    .filter((a) => a.categorySlug === article.categorySlug && a.id !== article.id)
    .slice(0, 4);

  const content = articleContentMock[article.slug] || getDefaultContent(article.title);

  return (
    <>
      <Navbar />
      <main>
        {/* Breadcrumb */}
        <nav className="w-full bg-background-100 border-b border-background-200/70" aria-label="面包屑导航">
          <div className="w-full px-4 md:px-6 py-3">
            <ol className="flex items-center gap-2 text-sm text-foreground-600">
              <li><Link to="/" className="hover:text-primary-600 transition-colors">首页</Link></li>
              <li><div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line text-xs text-foreground-400" /></div></li>
              <li>
                <Link to={`/category/${article.categorySlug}`} className="hover:text-primary-600 transition-colors">
                  {article.category}
                </Link>
              </li>
              <li><div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line text-xs text-foreground-400" /></div></li>
              <li className="text-foreground-900 font-medium" aria-current="page">{article.title}</li>
            </ol>
          </div>
        </nav>

        <div className="w-full px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-8 py-10 md:py-14">
            {/* Main Article */}
            <article className="flex-1 min-w-0">
              {/* Article Meta */}
              <div className="mb-6">
                <Link
                  to={`/category/${article.categorySlug}`}
                  className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 hover:bg-primary-200 transition-colors mb-4"
                >
                  {article.category}
                </Link>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 leading-snug mb-4">
                  {article.title}
                </h1>
                <div className="flex items-center gap-4 text-sm text-foreground-500 flex-wrap">
                  <span className="flex items-center gap-1.5">
                    <div className="w-4 h-4 flex items-center justify-center"><i className="ri-user-line text-xs" /></div>
                    {article.author}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <div className="w-4 h-4 flex items-center justify-center"><i className="ri-time-line text-xs" /></div>
                    {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <div className="w-4 h-4 flex items-center justify-center"><i className="ri-eye-line text-xs" /></div>
                    {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                  </span>
                </div>
              </div>

              {/* Article Image */}
              <div className="rounded-lg overflow-hidden mb-8">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 吃瓜黑料在线`}
                  className="w-full h-auto max-h-[480px] object-cover object-top"
                  loading="lazy"
                />
              </div>

              {/* Article Content */}
              <div
                className="text-base text-foreground-800 leading-relaxed [&_h3]:text-xl [&_h3]:font-heading [&_h3]:font-bold [&_h3]:text-foreground-900 [&_h3]:mt-8 [&_h3]:mb-3 [&_p]:leading-relaxed [&_p]:text-foreground-700 space-y-1"
                dangerouslySetInnerHTML={{ __html: content }}
              />

              {/* Tags */}
              <div className="mt-10 pt-6 border-t border-background-200/70">
                <h4 className="text-sm font-semibold text-foreground-700 mb-3">相关标签：</h4>
                <div className="flex flex-wrap gap-2">
                  {article.tags.map((tag) => (
                    <Link
                      key={tag}
                      to={`/?tag=${tag}`}
                      className="px-3 py-1.5 rounded-full text-xs bg-background-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700 transition-colors"
                    >
                      {tag}
                    </Link>
                  ))}
                </div>
              </div>

              {/* Share */}
              <div className="mt-8 flex items-center gap-3">
                <span className="text-sm text-foreground-600">分享到：</span>
                <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-secondary-200 text-foreground-600 transition-colors cursor-pointer" aria-label="微信分享">
                  <i className="ri-wechat-line text-lg" />
                </button>
                <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-secondary-200 text-foreground-600 transition-colors cursor-pointer" aria-label="微博分享">
                  <i className="ri-weibo-line text-lg" />
                </button>
                <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-secondary-200 text-foreground-600 transition-colors cursor-pointer" aria-label="复制链接">
                  <i className="ri-link text-lg" />
                </button>
              </div>

              {/* Related Articles */}
              {related.length > 0 && (
                <div className="mt-12 pt-8 border-t border-background-200/70">
                  <h3 className="text-xl font-heading font-bold text-foreground-900 mb-6">相关推荐</h3>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                    {related.map((a) => (
                      <div key={a.id} className="group flex gap-3">
                        <Link to={`/article/${a.slug}`} className="shrink-0">
                          <div className="w-24 h-20 rounded-lg overflow-hidden bg-background-100">
                            <img
                              src={a.image}
                              alt={a.title}
                              title={`${a.title} - 吃瓜黑料在线`}
                              className="w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                              loading="lazy"
                            />
                          </div>
                        </Link>
                        <div className="flex flex-col justify-between min-w-0">
                          <Link to={`/article/${a.slug}`}>
                            <h4 className="text-sm font-medium text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                              {a.title}
                            </h4>
                          </Link>
                          <span className="text-xs text-foreground-500">{a.publishDate}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* FAQ Section */}
              <div className="mt-12 pt-8 border-t border-background-200/70">
                <h3 className="text-xl font-heading font-bold text-foreground-900 mb-6">常见问题</h3>
                <div className="space-y-4">
                  <div className="bg-background-100 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-foreground-800 mb-2">什么是吃瓜黑料在线？</h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      吃瓜黑料在线是一个专注于网红塌房现场、博主反差视频及独家吃瓜爆料的内容聚合平台，为网友提供最新最全的吃瓜资讯。
                    </p>
                  </div>
                  <div className="bg-background-100 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-foreground-800 mb-2">本站内容是否属实？</h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      本站内容来源于公开信息和多方爆料整理，仅供参考。部分内容可能未经当事人核实，请读者理性看待。
                    </p>
                  </div>
                  <div className="bg-background-100 rounded-lg p-4">
                    <h4 className="text-sm font-semibold text-foreground-800 mb-2">如何订阅最新爆料？</h4>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      您可以在本站首页订阅我们的邮件推送，第一时间获取最新爆料和独家内容更新。
                    </p>
                  </div>
                </div>
              </div>
            </article>

            {/* Sidebar */}
            <div className="w-full lg:w-[340px] shrink-0">
              <div className="lg:sticky lg:top-20">
                <TrendingSidebar />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'http://dlhuayan.cn/' },
              { '@type': 'ListItem', position: 2, name: article.category, item: `http://dlhuayan.cn/category/${article.categorySlug}` },
              { '@type': 'ListItem', position: 3, name: article.title, item: `http://dlhuayan.cn/article/${article.slug}` },
            ],
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            image: article.image,
            datePublished: article.publishDate,
            author: {
              '@type': 'Organization',
              name: article.author,
            },
            publisher: {
              '@type': 'Organization',
              name: '吃瓜黑料在线',
              logo: {
                '@type': 'ImageObject',
                url: 'http://dlhuayan.cn/logo.png',
              },
            },
            url: `http://dlhuayan.cn/article/${article.slug}`,
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': `http://dlhuayan.cn/article/${article.slug}`,
            },
            articleSection: article.category,
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: `${article.title} - 吃瓜黑料在线`,
            description: article.excerpt,
            url: `http://dlhuayan.cn/article/${article.slug}`,
            isPartOf: { '@type': 'WebSite', name: '吃瓜黑料在线' },
          }),
        }}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '什么是吃瓜黑料在线？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '吃瓜黑料在线是一个专注于网红塌房现场、博主反差视频及独家吃瓜爆料的内容聚合平台，为网友提供最新最全的吃瓜资讯。',
                },
              },
              {
                '@type': 'Question',
                name: '本站内容是否属实？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '本站内容来源于公开信息和多方爆料整理，仅供参考。部分内容可能未经当事人核实，请读者理性看待。',
                },
              },
              {
                '@type': 'Question',
                name: '如何订阅最新爆料？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以在本站首页订阅我们的邮件推送，第一时间获取最新爆料和独家内容更新。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}